var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-container",class:_vm.local ? '' : 'fullpage'},[_c('div',{staticClass:"loader"})])
}
var staticRenderFns = []

export { render, staticRenderFns }